import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Container, Input, Row, Table } from 'reactstrap';
import { toast } from "react-toastify";
import _ from 'lodash';
import { FilterSelect, ServiceThreadSpinner } from '.';
import { api, filterHelpers } from '../utils';
import { confirmAlert } from "react-confirm-alert";

export default function ManagePcrTypes() {
   const DFLT_OPT = { value: 0, label: "-- Select --" };
   const PCR_MODEL = { typeId: 0, typeName: "" };
   const [pcrType, setPcrType] = useState(PCR_MODEL);
   const [pcrList, setPcrList] = useState([]);
   const [filters, setFilters] = useState([
      { filterName: "pcrType", value: DFLT_OPT }
   ]);
   const [editPcr, setEditPcr] = useState("");
   const [newPcr, setNewPcr] = useState("");
   const [origPcr, setOrigPcr] = useState("");
   const [spinPcr, setSpinPcr] = useState(true);

   useEffect(() => {
      runQuery();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   useEffect(() => {
      if (!pcrType || pcrType.typeId === 0)
         return; // PCR type was reset to initial state

      if (!editPcr || editPcr.length < 1)
         return; // Not editing       

      if (pcrType.typeName === origPcr)
         return; // No change made to PCR type being edited

      if (pcrType.typeName.length < 3) { // Do we need this?
         toast.error("Type description must be at least 3 characters");
         return;
      }
      UpdatePCR();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [pcrType])

   function DeletePCR() {
      setSpinPcr(true);
      api.post(`Engineering/DeletePcrType/${pcrType.typeId}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("PCR type was successfully deleted!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinPcr(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinPcr(false);
         });
   }

   function onPCRChange(newFilterValue) {
      let newFilters = filterHelpers.getFilters(filters, newFilterValue);
      setFilters(newFilters);

      setNewPcr(""); // Clear any lingering values
      if (newFilterValue.value === 0) {
         setPcrType(PCR_MODEL);
         setOrigPcr("");
         setEditPcr("");
      }
      else { // Get the PCR type to be edited
         let changes = Object.assign({}, pcrType);
         changes.typeName = newFilterValue.label;
         changes.typeId = newFilterValue.value;
         setPcrType(changes);
         setOrigPcr(newFilterValue.label);
         setEditPcr(newFilterValue.label);
      }
   }

   function onPCRUpdate() {
      let changes = Object.assign({}, pcrType);
      changes.typeName = editPcr
      setPcrType(changes);
   }

   function runQuery() {
      setSpinPcr(true);
      api
         .fetch(`Engineering/GetPcrTypes`)
         .then((response) => {
            if (response.data.success) {
               const dfList = _.concat([DFLT_OPT],
                  _.map(response.data.types, (d) => ({
                     value: d.typeId,
                     label: d.typeName
                  })));
               return { dfList: dfList };
            } else {
               toast.error(response.data.message);
            }
         })
         .then(({ dfList }) => {
            setPcrList(dfList);
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
         .finally(() => {
            setEditPcr("");
            setOrigPcr("");
            setNewPcr("")
            setPcrType(PCR_MODEL);
            setSpinPcr(false);
         });
   }

   function SaveNewPcrType() {
      if (!newPcr || newPcr.length < 1) {
         toast.error("Please provide a type description");
         return;
      }
      if (newPcr.length < 3) {
         toast.error("Type description must be at least 3 characters");
         return;
      }
      let payload = PCR_MODEL;
      payload.typeName = newPcr;
      
      setSpinPcr(true);
      api.post(`Engineering/SavePcrType/${newPcr}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("PCR type created!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinPcr(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinPcr(false);
         });
   }

   function UpdatePCR() {
      setSpinPcr(true);
      api.post('Engineering/UpdatePcrType', pcrType)
         .then((response) => {
            if (response.data.success) {
               toast.success("PCR type updated!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinPcr(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinPcr(false);
         });
   }

   const ShowDeleteModal = () => {
      if (!pcrType || pcrType.typeId === 0) {
         toast.error("Please select a PCR type");
         return;
      }
      confirmAlert({
         title: "Confirm Deletion",
         message: `Are you sure you want to delete the ${editPcr} PCR type?`,
         buttons: [
            { label: "Yes", onClick: () => { DeletePCR() }},
            { label: "No" }
         ]
      });
   }

   return (
      <Container fluid>
         <Row>
            <Col>
               <Fragment>
                  <ServiceThreadSpinner on={spinPcr}>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           {/* Select Type */}
                           {pcrList && pcrList.length ? (
                              <Table className="transparent-background my-0">
                                 <tbody>
                                    <tr>
                                       <td className="transparent-background data-cell noWrap h6" width="80px">
                                          PCR Type:
                                       </td>
                                       <td className="transparent-background width350px">
                                          <FilterSelect
                                             filterName="pcrType"
                                             options={pcrList}
                                             value={filterHelpers.getValue(filters, "pcrType")}
                                             onChangeCallback={e => onPCRChange(e)}
                                          />
                                       </td>
                                       <td className="transparent-background"></td>
                                    </tr>
                                 </tbody>
                              </Table>
                           ) : null}
                        </Col>
                     </Row>
               
                     {/* Edit Type */}
                     {pcrType && pcrType.typeId > 0 ? (
                        <div>
                           <Row className="px-0 py-0">
                              <Table className="transparent-background data-table">
                                 <tbody>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td colSpan={5} className="transparent-background data-cell noWrap h6">
                                          PCR types can only be deleted if there are no PCR records associated with the type.
                                       </td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell width95px noWrap h6">
                                          Id: {pcrType.typeId}
                                       </td>
                                       <td colSpan={4} className="transparent-background data-cell"></td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell noWrap h6 width115px">
                                          Type Name:
                                       </td>
                                       <td className="transparent-background data-cell width350px">
                                          <Input
                                             type="text"
                                             value={editPcr || ""}
                                             onChange={(e) => setEditPcr(e.target.value)}
                                             maxLength="100"
                                          />
                                       </td>
                                       <td className="transparent-background data-cell width115px">
                                          <Button
                                             title="Update"
                                             className="shredButton"
                                             onClick={() => onPCRUpdate()}
                                          >
                                             Update
                                          </Button>
                                       </td>
                                       <td className="transparent-background data-cell width115px">
                                          <Button
                                             title="Delete"
                                             className="shredButton"
                                             onClick={() => ShowDeleteModal()}
                                          >
                                             Delete
                                          </Button>
                                       </td>
                                       <td className="transparent-background data-cell"></td>
                                    </tr>
                                 </tbody>
                              </Table>
                           </Row>
                        </div>
                     ) : null}

                     {/* Add New Type */}
                     <br />
                     <br />
                     <hr/>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           Add New Type
                        </Col>
                     </Row>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           <Table className="transparent-background my-0">
                              <tbody>
                                 <tr>
                                    <td className="transparent-background data-cell noWrap h6" width="80px">
                                       Type Name:
                                    </td>
                                    <td className="transparent-background width350px">
                                       <Input
                                          type="text"
                                          value={newPcr || ""}
                                          onChange={(e) => setNewPcr(e.target.value)}
                                          maxLength="100"
                                       />
                                    </td>
                                    <td className="transparent-background">
                                       <Button
                                          title="New Type"
                                          className="shredButtonExcel ms-2"
                                          onClick={() => SaveNewPcrType()}
                                       >
                                          Add Type
                                       </Button>
                                    </td>
                                 </tr>
                              </tbody>
                           </Table>
                        </Col>
                     </Row>
                  </ServiceThreadSpinner>
               </Fragment>
            </Col>
         </Row>
      </Container>
   );
}
